import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Shell from "@/components/Shell";
import AmbientBackground from "@/components/AmbientBackground";
import Login from "@/pages/Login";
import WarRoom from "@/pages/WarRoom";
import BusinessPage from "@/pages/BusinessPage";
import Money from "@/pages/Money";
import WaitingOnPage from "@/pages/WaitingOnPage";
import Reports from "@/pages/Reports";
import SallyHistory from "@/pages/SallyHistory";
import Settings from "@/pages/Settings";
import { getToken, verifyToken } from "@/lib/api";
import { EditModeProvider } from "@/lib/EditModeContext";

const RequireAuth = ({ children }) => {
  const [state, setState] = useState({ loading: true, ok: false });
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    const t = getToken();
    if (!t) { setState({ loading: false, ok: false }); return; }
    verifyToken().then((ok) => alive && setState({ loading: false, ok }));
    return () => { alive = false; };
  }, [location.pathname]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="op-microcopy op-flicker">BOOT · SYSTEM</div>
      </div>
    );
  }
  if (!state.ok) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const t = getToken();
  return t ? <Navigate to="/" replace /> : children;
};

function App() {
  return (
    <div className="App">
      <AmbientBackground />
      <Toaster
        theme="dark"
        position="bottom-left"
        toastOptions={{
          style: {
            background: "#0A0C14",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#fff",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.12em",
          },
        }}
      />
      <EditModeProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route
            path="/*"
            element={
              <RequireAuth>
                <Shell>
                  <Routes>
                    <Route index element={<WarRoom />} />
                    <Route path="pyn-capital" element={<BusinessPage slug="pyn-capital" />} />
                    <Route path="doa" element={<BusinessPage slug="doa" />} />
                    <Route path="biovault" element={<BusinessPage slug="biovault" />} />
                    <Route path="personal" element={<BusinessPage slug="personal" />} />
                    <Route path="money" element={<Money />} />
                    <Route path="waiting-on" element={<WaitingOnPage />} />
                    <Route path="reports" element={<Reports />} />
                    <Route path="sally-history" element={<SallyHistory />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Shell>
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
      </EditModeProvider>
    </div>
  );
}

export default App;
